import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";
import { Toggle } from "src/UI/Toggle";

const UrlResContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`, { value: 32 }) || "" : "";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InputCst
        id="activity-url-res"
        label={`${t("content.url-res.url")} *`}
        value={data.external_file_url}
        onChange={(e: any) => setData({ external_file_url: e.target.value })}
        placeholder={
          data.is_link_relative
            ? t("content.url-res.placeholder-relative") || ""
            : t("content.url-res.placeholder-absolute") || ""
        }
        error={!!errors.external_file_url}
        errorMessage={errMsg("external_file_url")}
      />

      <Toggle
        label={t("content.url-res.is-link-relative")}
        checked={data.is_link_relative}
        onChange={(next) => setData({ is_link_relative: next })}
      />
      <Toggle
        label={t("content.url-res.is-editorial")}
        checked={data.is_editorial}
        onChange={(next) => setData({ is_editorial: next })}
      />
      <Toggle
        label={t("content.url-res.completion-required")}
        checked={data.completion_required}
        onChange={(next) => setData({ completion_required: next })}
      />
      <Toggle
        label={t("content.url-res.flag-authentication")}
        checked={data.flag_authentication}
        onChange={(next) => setData({ flag_authentication: next })}
      />

      {data.flag_authentication && (
        <>
          <InputCst
            id="activity-url-res-client-id"
            label={`${t("content.url-res.client-id")} *`}
            value={data.client_id}
            onChange={(e: any) => setData({ client_id: e.target.value })}
            error={!!errors.client_id}
            errorMessage={errMsg("client_id")}
          />
          <InputCst
            id="activity-url-res-client-secret"
            label={`${t("content.url-res.client-secret")} *`}
            value={data.client_secret}
            onChange={(e: any) => setData({ client_secret: e.target.value })}
            error={!!errors.client_secret}
            errorMessage={errMsg("client_secret")}
          />
        </>
      )}
    </Box>
  );
};

export default UrlResContent;
